import Header from '../components/header/header'
import HeaderImage from '../images/headers/ou-flowers.jpg'
import Diamond from '../images/Diamond.png'
import '../style/sponsor.css'
import '../App.css';
import React from "react";
import Button from "react";
// import CustomLink from '../components/navigation/customlink';
import {Link} from "react-router-dom";
import CanvaEmbed from "../components/CanvaEmbed";

const Sponsor = () => {
    return (
        <>
            {/*<header>*/}
            {/*    <Header text="" text2="" tag="sponsorship" backgroundImage={HeaderImage}/>*/}
                {/*<div className="thankyou">*/}
                {/*    <h5>*/}
                {/*        This event wouldn't be possible without you!*/}
                {/*    </h5>*/}
                {/*    <p>*/}
                {/*        We extend our deepest gratitude to all our current <br/>*/}
                {/*        and future sponsors for their invaluable contributions. <br/>*/}
                {/*        Your generosity and commitment will help shape the <br/>*/}
                {/*        skills and potential of tomorrow's Biomedical Engineers.*/}
                {/*    </p>*/}
                {/*</div>*/}
            {/*</header>*/}

            <body>

            <div className="become-sponsor">
                Become a Sponsor
            </div>

            {/* <CustomLink to="https://utexas.qualtrics.com/jfe/form/SV_2uDs0L0BplRJN78" target="_blank" rel="noopener noreferrer" className="sponsor-survey">Survey</CustomLink> */}

            {/* <CanvaEmbed /> */}


            {/* TEMPORARY BUTTON TO CANVA */}
            <div className="canva-button-container">
                        <a href="https://www.canva.com/design/DAGul2wsZxA/Hc9YfpkMiivhKdg1lPTtqA/view?utm_content=DAGul2wsZxA&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=he865fcad0b"
            target="_blank"
            rel="noopener noreferrer"
            id="canva-button"
            >View Sponsorship Tiers</a> 
            </div>
            

    <div className="small-donations">
      {/* Section 1: Our Objectives */}
      <section className="objectives">
        <h2>Our Objectives</h2>
        <p>
          Since UT teams began competing at MDM, we have seen how this competition
          has grown both in reach and execution. Our goal is to continue growing
          MDM—supporting medical innovation and career preparation, strengthening
          connections with Texas’ innovation ecosystem, and coalescing diverse
          talent from across the nation.
        </p>
        <p>To reduce the cost barrier for attendees, we will direct donations towards:</p>
        <ul>
          <li>Providing 6 dietary restriction-friendly meals to participants, judges, mentors, and volunteers</li>
          <li>Hiring UTPD officers to be on-site during the event</li>
          <li>Hiring Texas Inventionworks staff to assist in 3D-printing teams' prototypes</li>
          <li>Reimbursing a portion of participants’ attendance fees and/or travel costs</li>
          <li>Awarding cash prizes to the top five teams</li>
          <li>Gifting each participant an MDM T-shirt</li>
        </ul>
      </section>

      {/* Section 2: MDM in Pictures */}
      <section className="pictures">
        <h2>MDM in Pictures</h2>
        <div className="image-stack">
          {/* Replace with actual <img src="..." alt="..."/> */}
          <img src="/images/donation-pics/MDM-in-pictures-1.png" alt="MDM in pictures" loading="lazy"/>
          <img src="/images/donation-pics/MDM-in-pictures-2.png" alt="MDM in pictures" loading="lazy"/>
        </div>
      </section>

      {/* Section 3: Levels of Support */}
      <section className="support-levels">
        <h2>Levels of Support</h2>
        <ul>
          <li><strong>$30</strong> → Supports one hour of service from a Texas Inventionworks staff member assisting with 3D printing</li>
          <li><strong>$70</strong> → Supports one hour of service from a UTPD officer</li>
          <li><strong>$150</strong> → Number of MDM participants</li>
          <li><strong>$200</strong> → Provides 20 T-shirts for MDM attendees</li>
          <li><strong>$600</strong> → Funds the second-place team prize</li>
          <li><strong>$900</strong> → Supports Saturday night dinner for judges and mentors</li>
        </ul>
      </section>

      {/* Small Donation CTA */}
      <section className="donation-cta">
        <h2>Contribute What You Can</h2>
        <p>
          Every contribution, no matter the size, helps us make MDM more accessible
          and impactful for all participants. Whether you’re an alum, a parent, or
          simply someone who believes in fostering innovation—your support matters!
          100% of your donation goes directly to the MDM competition.
        </p>
        <p>
            Please see this <a href="https://docs.google.com/forms/d/e/1FAIpQLSeSOrR-T4HAwoJ6vBDsxo9B8OJ8-X2HC1rnhPTAEiV_xkiLMA/viewform" 
    target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline", color: "black" }}>form</a> for instructions
        </p>
        <a
          href="https://give.utexas.edu/campaigns/59328/donations/new"
          target="_blank"
          rel="noopener noreferrer"
          className="donate-button"
        >
          Donate Now
        </a>
      </section>
    </div>





            {/* <div className="cheaper-sponsor-tiers">
                <div className="border" id="cheap-tier">
                    <div className="tier">
                        <h4>Startup</h4>
                        <p className="price">$300</p>
                        <ul>
                            <li><span>Logo on MDM website and social media</span></li>
                            <li><span>Table at networking fair</span></li>
                        </ul>
                    </div>
                </div>
                <div className="border" id="cheap-tier">
                    <div className="tier">
                        <h4>Student Orgs</h4>
                        <p className="price">$300</p>
                        <ul>
                            <li><span>Logo on MDM website and social media</span></li>
                            <li><span>Table at networking fair</span></li>
                        </ul>
                    </div>
                </div>
            </div> */}

            <div className="sponsor-tiers">
                {/* BRONZE LEVEL SPONSOR*/}
                {/* <div className="border" id="bronze">
                    <div className="tier">
                        <h4>BRONZE</h4>
                        <p className="price">$500</p>
                        <ul>
                            <li><span>Table at networking fair</span></li>
                            <li><span>Enamel Pins</span></li>
                            <li><span>Company logo on<br/>MDM website and social media</span></li>
                        </ul>
                    </div>
                </div> */}
                {/* SILVER LEVEL SPONSOR */}
                {/* <div className="border" id="silver">
                    <div className="tier">
                        <h4>SILVER</h4>
                        <p className="price">$800</p>
                        <ul>
                            <li><span>Table at networking fair</span></li>
                            <li><span>Enamel Pins</span></li>                            
                            <li><span>Company logo on<br/>MDM website, social media, and shirts</span></li>
                            <li><span>Bi-monthly committee event progress reports</span></li>
                            <li><span>Plaque with name of sponsor</span></li>
                            <li><span>MDM 2026 tumblers</span></li>
                        </ul>
                    </div>
                </div> */}
                {/* GOLD LEVEL SPONSOR */}
                {/* <div className="border" id="gold">
                    <div className="tier">
                        <h4>GOLD</h4>
                        <p className="price">$2500</p>
                        <ul>
                            <li><span>Table at networking fair</span></li>
                            <li><span>Enamel Pins</span></li>                            
                            <li><span>Company logo on<br/>MDM website and social media</span></li>
                            <li><span>Bi-monthly committee event progress reports</span></li>
                            <li><span>Plaque with name of sponsor</span></li>
                            <li><span>Water bottles</span></li> 
                            <li><span>Company spotlight post on Instagram before the event</span></li>
                            <li><span>Access to participant resume bank and LinkedIn group</span></li>
                            <li><span>Announcement and distribution of company pamphlet during lunch</span></li>
                        </ul>
                    </div>
                </div> */}
                
            
            </div>
            {/*<Button title="Sponsor-Button" onPress={()=>}></Button>*/}
            <div className="sponsor-tiers">
                {/* DIAMOND LEVEL SPONSOR */}
                {/* <div className="diamond glow">
                    <div className="tier" id="diamond-tier">
                        <div className="diamond-split">
                            <h4>DIAMOND</h4>
                            <p className="price">$5,000</p>
                        </div>
                        <ul>
                            <li><span>Ability to vote on the clinical issue</span></li>
                    <li><span>First choice of networking fair table placement</span></li>
                            <li><span>Company logo on awards and main banner</span></li>
                            <li><span>All Bronze, Silver, and Gold benefits</span></li>
                        </ul>
                    </div>
                </div> */}
            </div>


            <div className="sponsor-page">
                {/*    ALL CURRENT SPONSORS    */}
                <div className="sponsors">
                    <h2> Sponsors </h2>
                    {/* <img src={"/sponsors/LifeScienceOK.png"} alt={"Life Science Oklahoma"} loading="lazy"/>
                    <img src={"/sponsors/OKCchamber.jpeg"} alt={"OKC Chamber"} loading="lazy"/>
                    <img src={"/sponsors/ou-bme.png"} alt={"sponsor"} loading="lazy"/>
                    <img src={"/sponsors/BMES2019.png"} alt={"BME UIUC"} loading="lazy"/>
                    <img src={"/sponsors/Society_of_Petroleum_Engineers_Logo.svg.png"}
                         alt={"Society of Petroleum Ingineers"} loading="lazy"/>
                    <img src={"/sponsors/Coca-Cola.png"} alt={"Coca-Cola"} loading="lazy"/>
                    <img src={"/sponsors/Medtronic.jpeg"} alt={"Medtronic"} loading="lazy"/>
                    <img src={"/sponsors/Immy.png"} alt={"Immy"} loading="lazy"/>
                    <img src={"/sponsors/Gallogly-OU-Eng.png"} alt={"OU-Gallogly"} loading="lazy"/>
                    <img src={"/sponsors/red-bull.png"} alt={"Red Bull"} loading="lazy"/>
                    <img src={"/sponsors/OKBioStart.png"} alt={"OKBioStart"} loading="lazy"/> */}

                    <img src={"/sponsors/texas_am_engineering_medicine_logo.jpg"} alt={"Texas A&M"} loading="lazy"/>
                    {/* <img src={"/sponsors/BMES_Logo.webp"} alt={"BMES"} loading="lazy"/> */}
                    <img src={"/sponsors/SEC_logo.jpg"} alt={"SEC"} loading="lazy"/>
                    <img src={"/sponsors/Cockrell_CMYK_formal_BME-cropped.svg"} alt={"Cockrell School"} loading="lazy"/>
                    <img src={"/sponsors/BMES-UTaustin.png"} alt={"Cockrell School"} loading="lazy"/>
                    <img src={"/sponsors/sii_bruker_blifli_small_black.png"} alt={"Spectal Instruments Imaging"} loading="lazy"/>
                    <img src={"/sponsors/united_therapeutics.png"} alt={"United Therapeutics"} loading="lazy"/>
                    <img src={"/sponsors/Hi-Re-Logo.jpg"} alt={"Hi-Re"} loading="lazy"/>

                    {/* Use this as a place holder */}
                    {/*<img src={require("../images/logoplaceholder.png")} alt={"logo place holder"} id="placeholder"/>*/}

                </div>

                {/*    DIAMOND LEVEL SPONSOR    */}
                {/* <div className="feature-diamond">
                    <div id="year">2<br/>0</div>
                    <div id="feature-glow">
                        <img src={Diamond} alt={"Diamond Sponsor"} className="feature" loading="lazy"/>
                    </div>
                    <div id="year">2<br/>6</div>
                </div> */}

            </div>

                        <div className="partners-page">
                {/*    ALL CURRENT SPONSORS    */}
                <div className="partners">
                    <h2> Partners </h2>
                    <img src={"/sponsors/RGB_formal_Office_of_Innovation_and_Entrepreneurship.png"} alt={"RGB"} loading="lazy"/>
                    <img src={"/sponsors/ATI-logo.png"} alt={"ATI"} loading="lazy"/>

                    {/* Use this as a place holder */}
                    {/*<img src={require("../images/logoplaceholder.png")} alt={"logo place holder"} id="placeholder"/>*/}

                </div>
            </div>

            
            </body>
        </>
    );
};
export default Sponsor;